import classnames from 'classnames';
import React from 'react';
import UI from '../../commons/services/UI';
import { isPremium, openBillingPage } from '../../commons/services/Wix';
import { badgesList, getNormalizedBadgeId } from '../../commons/badges/index';

function BadgesTab({ onUpdate, data, styles, fetchStyles }) {
  const selectedBadge = getNormalizedBadgeId(data.selectedBadge);

  const badgesHTML = badgesList.map(({ BadgeComponent, id, premium }) => {
    return (
      <div
        onClick={() => {
          if (!premium || isPremium()) {
            onUpdate(data, { selectedBadge: { $set: id } });
          }
        }}
        onMouseEnter={() => {
          onUpdate(data, { hoverBadge: { $set: id } }, false);
        }}
        onMouseLeave={() => {
          onUpdate(data, { $unset: ['hoverBadge'] }, false);
        }}
        className={classnames('BadgesOverview__Badge', {
          'BadgesOverview__Badge--selected': selectedBadge === id,
          'BadgesOverview__Badge--disablePointer': premium && !isPremium()
        })}
      >
        <div className="BadgesOverview__BadgeInnerWrapper">
          <BadgeComponent data={data} styles={styles} />
          {premium &&
            !isPremium() &&
            <div className="BadgesOverview__PremiumBadge">
              <UI.tooltip value="Upgrade to use this sign design.">
                <UI.symbol
                  name="premiumLarge"
                  style={{ cursor: 'pointer' }}
                  onClick={openBillingPage}
                />
              </UI.tooltip>
            </div>}
        </div>
      </div>
    );
  });

  return (
    <div>
      <UI.sectionDividerLabeled label="Choose a Sign" />
      <hr className="divider-long" />
      <div className="BadgesOverview">
        {badgesHTML}
      </div>
      <div style={{ height: '200px' }} />
    </div>
  );
}

export default BadgesTab;



// WEBPACK FOOTER //
// ./src/apps/settings/BadgesTab.jsx